import { Controller } from "@hotwired/stimulus";
import "./OnboardingStep.scss";

export default class OnboardingStepController extends Controller {
    // nothing here so far
}
